var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10954_47023)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10954_47023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9099 8.70521C11.9099 10.2806 10.6329 11.5576 9.05751 11.5576C7.48215 11.5576 6.20508 10.2806 6.20508 8.70521C6.20508 7.12986 7.48215 5.85278 9.05751 5.85278C10.6329 5.85278 11.9099 7.12986 11.9099 8.70521ZM10.4837 8.70521C10.4837 7.91754 9.84518 7.279 9.05751 7.279C8.26984 7.279 7.63129 7.91754 7.63129 8.70521C7.63129 9.49288 8.26984 10.1314 9.05751 10.1314C9.84518 10.1314 10.4837 9.49288 10.4837 8.70521Z",
    fill: "#A6B0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.78314C0.5 3.79853 1.29817 3.00037 2.28277 3.00037H15.8318C16.8165 3.00037 17.6146 3.79853 17.6146 4.78314V12.6273C17.6146 13.612 16.8165 14.4101 15.8318 14.4101H2.28277C1.29817 14.4101 0.5 13.612 0.5 12.6273V4.78314ZM2.28277 4.42658C2.08585 4.42658 1.92622 4.58622 1.92622 4.78314V5.8528H2.63932C3.03316 5.8528 3.35243 5.53352 3.35243 5.13969V4.42658H2.28277ZM1.92622 12.6273C1.92622 12.8242 2.08585 12.9839 2.28277 12.9839H3.35243V12.2708C3.35243 11.8769 3.03316 11.5577 2.63932 11.5577H1.92622V12.6273ZM4.77865 12.2708V12.9839H13.3359V12.2708C13.3359 11.0892 14.2938 10.1314 15.4753 10.1314H16.1884V7.27901H15.4753C14.2938 7.27901 13.3359 6.32121 13.3359 5.13969V4.42658H4.77865V5.13969C4.77865 6.32121 3.82084 7.27901 2.63932 7.27901H1.92622V10.1314H2.63932C3.82084 10.1314 4.77865 11.0892 4.77865 12.2708ZM14.7622 12.9839H15.8318C16.0288 12.9839 16.1884 12.8242 16.1884 12.6273V11.5577H15.4753C15.0815 11.5577 14.7622 11.8769 14.7622 12.2708V12.9839ZM16.1884 5.8528V4.78314C16.1884 4.58622 16.0288 4.42658 15.8318 4.42658H14.7622V5.13969C14.7622 5.53352 15.0815 5.8528 15.4753 5.8528H16.1884Z",
    fill: "#A6B0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49218 17.2625C4.54147 17.2625 3.7356 16.6424 3.45703 15.7845C3.65492 15.8186 3.85837 15.8363 4.06597 15.8363H15.8322C17.6045 15.8363 19.0412 14.3995 19.0412 12.6273V5.97449C19.8721 6.26817 20.4674 7.06061 20.4674 7.99208V12.6273C20.4674 15.1872 18.3922 17.2625 15.8322 17.2625H5.49218Z",
    fill: "#A6B0CF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10954_47023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0521,
    height: 20.0521,
    fill: "white",
    transform: "translate(0.603516 0.473999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10954_47023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.000366211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.06f72bd2.svg";
export { ForwardRef as ReactComponent };